import { z } from 'zod'
import {
  Address,
  ChainID,
  HexNumber,
} from '@lukso/controllerapps-sharedlogic-primitives'

import { Profile } from '../../Profile'
import * as CustomControllerNameSchemaMap from './CustomControllerNameSchema'
import { ProfileName } from '../../ProfileName'
import { ProfileAddress } from '../../../ProfileAddress'
import { ControllerAddress } from '../../ControllerAddress'

export const ProfileSchema = z.object({
  name: z.string().optional(),
  profileAddress: z.string(),
  chainID: z.number(),
  controllerAddress: z.string(),
  customControllerNames: z.array(
    CustomControllerNameSchemaMap.CustomControllerNameSchema
  ),
  readonly: z.boolean(),
})

type ProfileReportText = z.infer<typeof ProfileSchema>

export function mapDomainToReportText(profile: Profile): ProfileReportText {
  return {
    name: profile.getName()?.getValue(),
    profileAddress: profile.getAddress().getChecksumValue(),
    chainID: profile.getChainID().toNumber(),
    controllerAddress: profile.getControllerAddress().getChecksumValue(),
    customControllerNames: CustomControllerNameSchemaMap.mapDomainToReportText(
      profile.getCustomControllerNames()
    ),
    readonly: false,
  }
}

export function mapReportTextToDomain(reportText: ProfileReportText): Profile {
  const {
    name,
    profileAddress,
    chainID,
    controllerAddress,
    customControllerNames,
  } = reportText
  return Profile.create({
    name: name ? ProfileName.create({ profileNameValue: name }) : undefined,
    address: ProfileAddress.create({
      profileAddressValue: Address.create({
        addressValue: HexNumber.create({ hexNumberValue: profileAddress }),
      }),
    }),
    chainID: ChainID.create({ chainIDValue: chainID }),
    deviceControllerAddress: ControllerAddress.create({
      controllerAddressValue: Address.create({
        addressValue: HexNumber.create({ hexNumberValue: controllerAddress }),
      }),
    }),
    customControllerNames: CustomControllerNameSchemaMap.mapReportTextToDomain(
      customControllerNames
    ),
  })
}
